import React from 'react';
import { Divider } from '@mui/material';
import Container from '@mui/material/Container';
import styled from 'styled-components';

import Skeleton from '../../components/general/skeleton/Skeleton';
import {
    StyledContainer,
    StyledHeaderContainer,
} from '../../components/general/headers/HeaderWithDivider';

export const HeadlineContainer = styled.div`
    justify-content: space-between;
    display: grid;
    grid-template-columns: auto auto;
    align-items: center;
    margin-bottom: 15px;
`;

const height = '228px';
const width = '354px';

const cardSkeletonStyles = {
    borderRadius: 'var(--2, 16px)',
};

const ConnectionsPage = (): JSX.Element => {
    return (
        <Container sx={{ display: 'flex', flexDirection: 'column', gap: 5 }}>
            <StyledHeaderContainer>
                <StyledContainer>
                    <Skeleton $width="192px" $height={'45px'} />
                </StyledContainer>

                <Divider
                    orientation="horizontal"
                    sx={{
                        width: '100%',
                    }}
                />
            </StyledHeaderContainer>
            <Container
                sx={{ padding: '0 !important', display: 'flex', gap: 3 }}
            >
                <Skeleton
                    $height={height}
                    $width={width}
                    style={cardSkeletonStyles}
                />
                <Skeleton
                    $height={height}
                    $width={width}
                    style={cardSkeletonStyles}
                />
            </Container>
        </Container>
    );
};

export default ConnectionsPage;
